import { render } from "./Unit_Categories.vue?vue&type=template&id=f8dc08f6"
import script from "./Unit_Categories.vue?vue&type=script&lang=js"
export * from "./Unit_Categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__